jQuery(document).on('ready', function () {
    jQuery('.wm-optionBox__toggle, .wm-chapterOptionBox__toggle').on('click', function (e) {
        e.preventDefault();
        jQuery(this).parent().toggleClass('-active');
    });
});
